import { upsertBlock } from '~/agentic-ux/slice'
import { Block, DropdownBlock } from '~/protos/agents'
import store from '~/store'
import { AbsReactiveBlock } from './AbsReactiveBlock'

export class ReactiveDropdownBlock extends AbsReactiveBlock {
  constructor(block: DropdownBlock) {
    super()
    this.onSelect = this.onSelect.bind(this)
    this._block = Block.fromPartial({
      dropdownBlock: block
    })
  }

  public onSelect(option: string) {
    if (this._block.dropdownBlock) {
      this._block.dropdownBlock.selectedOption = option
      store.dispatch(upsertBlock({ id: this.id, block: this._block }))
    }
  }
}
